<script setup lang="ts">

import { AppText } from '@shared/ui/typography'

import CustomerKidBalance from './CustomerKidBalance.vue'
import { useCustomerBalance } from '../model/customer-balance.hook'

defineOptions({
  name: 'CustomerBalanceInfo',
})

const {
  refKids,
} = useCustomerBalance()
</script>

<template>
  <div class="customer-info-group">
    <AppText name="body1-medium">
      Lesson balance
    </AppText>
    <div class="customer-balance">
      <CustomerKidBalance
        v-for="kid in refKids"
        :key="kid.id"
        :kid="kid"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./CustomerInfoGroup.scss" />
